import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { motion } from "framer-motion";

class TableControls extends Component {
  static propTypes = {
    editor: PropTypes.object,
    value: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.removeRow = this.removeRow.bind(this);
    this.removeColumn = this.removeColumn.bind(this);
    this.insertRow = this.insertRow.bind(this);
    this.insertColumn = this.insertColumn.bind(this);
    this.removeTable = this.removeTable.bind(this);
  }

  removeRow() {
    this.props.editor.removeRow();
  }

  removeColumn() {
    this.props.editor.removeColumn();
  }

  insertRow() {
    this.props.editor.insertRow();
  }

  insertColumn() {
    this.props.editor.insertColumn();
  }

  removeTable() {
    this.props.editor.removeTable();
  }

  render() {
    return (
      <motion.div
        initial={{ opacity: 0, x: '-75%%' }}
        animate={{ opacity: 1, x: '-100%' }}
        exit={{ opacity: 0, x: '-75%' }}
        transition={{ ease: [0.18, 0.89, 0.39, 1.4], duration: .3 }}
        className="table_controls bg-white p-4 absolute shadow-md">
        <div className="button-group flex justify-between mb-6">
          <button
            title="Remove Row"
            onClick={this.removeRow}
            className="cursor-pointer font-bold normal-button p-0 rounded text-base outline-none">
            -
          </button>
          <span className="text-sm font-bold">Row</span>
          <button
            title="Insert Row"
            onClick={this.insertRow}
            className="cursor-pointer font-bold normal-button p-0 rounded text-base outline-none">
            +
          </button>
        </div>
        <div className="button-group flex justify-between mb-6">
          <button
            title="Remove Column"
            onClick={this.removeColumn}
            className="cursor-pointer font-bold normal-button p-0 rounded text-base outline-none">
            -
          </button>
          <span className="text-sm font-bold">Column</span>
          <button
            title="Insert Column"
            onClick={this.insertColumn}
            className="cursor-pointer font-bold normal-button p-0 rounded text-base outline-none">
            +
          </button>
        </div>
        <button
          title="Remove Table"
          onClick={this.removeTable}
          className="normal-button rounded p-1 font-bold cursor-pointer w-full outline-none text-sm">
          Remove Table
        </button>
      </motion.div>
    );
  }
}

export default  TableControls;
